
import {inject,computed} from 'vue'
export default {
    props:{
        data:{
            type:Object,
            default:{}
        }
    },
    setup(props: any){
        const $store: any = inject('$store')
        const currencyUnit:String = $store.getSymbol(); 
        let item = computed(()=>{         
            props.data.price = props.data.promotion_price ? props.data.promotion_price  : (props.data.goods_price ? props.data.goods_price : props.data.price)
             props.data.price_gray = props.data.goods_marketprice
           ? props.data.goods_marketprice
           : props.data.marketprice;
           props.data.name = props.data.goods_name ? props.data.goods_name : props.data.name
           return props.data
        })
        return {
            currencyUnit,
            item
        }   
    }
}
